import React, { useEffect, useState } from "react";
import { ComboBox, FormSection } from "../../../components";

export default function FormOpcoesApresentacao({ handleConsulta }) {
  const [consulta] = useState("");

  const handleInput = (event) => {
    const { name, value } = event.target;
    setConsulta({ ...consulta, [name]: value });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  return (
    <>
      <div className="main-content mt-1">
        <FormSection
          title="Dados fixos"
          borderBottomWidth={1}
          fontSizeClass="fs-18px"
        >
          <ComboBox items={[]} displayName="nome" placeholder="Nome" />

          <ComboBox items={[]} displayName="nome" placeholder="Série" />

          <ComboBox items={[]} displayName="nome" placeholder="RGN" />

          <ComboBox items={[]} displayName="nome" placeholder="RGD" />

          <ComboBox
            items={[]}
            displayName="nome"
            placeholder="Data Nascimento"
          />

          <ComboBox items={[]} displayName="nome" placeholder="Sexo" />

          <ComboBox items={[]} displayName="nome" placeholder="Raça" />

          <ComboBox items={[]} displayName="nome" placeholder="Categoria" />

          <ComboBox items={[]} displayName="nome" placeholder="Variedade" />

          <ComboBox items={[]} displayName="nome" placeholder="Opções 1" />

          <ComboBox items={[]} displayName="nome" placeholder="Opções 2" />

          <ComboBox items={[]} displayName="nome" placeholder="Opções 3" />

          <ComboBox items={[]} displayName="nome" placeholder="Opções 4" />
        </FormSection>
      </div>
    </>
  );
}
